<nb-card class="model-full">
  <nb-card-header>Editor de geometría</nb-card-header>


  <nb-card-body>

<div [nbSpinner]="loadingLocalidad" nbSpinnerStatus="danger" nbSpinnerSize="large" nbSpinnerMessage="Buscando localidad...">

  <div class="row">
    <div class="col-12">
      <div class="form-group">

        <input type="text" nbInput fullWidth id="busqueda" name="busqueda" placeholder="Localidad, Region, Pais" [(ngModel)]="busquedaLocalidad" (keyup.enter)="buscarLocalidad()" />
      </div>
    </div>
  </div>
  <div class="row">

    <div #mapa class="map-container container-geometria col-12" [attr.id]="config.target">
    </div>


  </div>
</div>

</nb-card-body>
<nb-card-footer>
  <div class="space-between">
  <button nbButton size="medium" status="info" (click)="cancelGeometry()"><nb-icon icon="close-outline"></nb-icon> Cancelar</button>
  <button nbButton size="small" status="danger" (click)="deleteGeometry()"><nb-icon icon="refresh-outline"></nb-icon> Borrar</button>
  <button nbButton size="medium" status="primary" (click)="saveGeometry()"><nb-icon icon="save-outline"></nb-icon> Aceptar</button>
</div>
</nb-card-footer>
</nb-card>
